import { useMutation, useQueryClient } from "@tanstack/react-query";

import { del, post } from "common/helpers/HTTP";

import type { AgencyDomain } from "../types";

async function addAgencyDomainRequest(
  domainName: string,
): Promise<AgencyDomain> {
  const { record } = await post(`agency/domains`, {
    name: domainName,
  });

  if (import.meta.env.MODE !== "production") {
    // biome-ignore lint/correctness/noUnusedVariables: Will be used for domain aliasing
    const deploymentDomain =
      import.meta.env.VITE_GIT_BRANCH_NAME === "dev"
        ? "app.aimfox.dev"
        : `${import.meta.env.VITE_GIT_BRANCH_NAME.replace("feature/", "")}-aimfox.vercel.app`;

    //alias the domain
  }
  return record;
}
async function removeAgencyDomainRequest(domain: string): Promise<unknown> {
  return (await del(`agency/domains/${domain}`)).token;
}

export default function useAgencyDomainsMutations() {
  const queryClient = useQueryClient();

  const { mutateAsync: addAgencyDomain, isPending: isAddingAgencyDomain } =
    useMutation({
      mutationFn: ({ domainName }: { domainName: string }) =>
        addAgencyDomainRequest(domainName),
      onSuccess: (addedDomain, { domainName }) => {
        queryClient.setQueryData(["agencyDomain", domainName], addedDomain);
      },
    });

  const { mutateAsync: removeAgencyDomain, isPending: isRemovingAgencyDomain } =
    useMutation({
      mutationFn: ({ domainName }: { domainName: string }) =>
        removeAgencyDomainRequest(domainName),
      onSuccess: () => {},
    });

  return {
    addAgencyDomain,
    isAddingAgencyDomain,
    removeAgencyDomain,
    isRemovingAgencyDomain,
  };
}
